import { Component, HostListener } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { TemplateService } from 'src/app/services/template.service';
import { PaymentsService } from 'src/app/services/payment_apis/payments.service';
import { UpgradePlanComponent } from 'src/app/master-config-components/micro-apps/website/popups/upgrade-plan/upgrade-plan.component';
import { LinkDomainComponent } from 'src/app/master-config-components/micro-apps/website/popups/link-domain/link-domain.component';
import { StepsToFollowComponent } from 'src/app/master-config-components/micro-apps/website/popups/steps-to-follow/steps-to-follow.component';
import { WebisiteService } from 'src/app/master-config-components/micro-apps/website/webisite.service';
import { ProcessInprogressComponent } from 'src/app/master-config-components/micro-apps/website/popups/process-inprogress/process-inprogress.component';
import { CustomSnackbarComponent } from 'src/app/helper-components/custom-snackbar/custom-snackbar.component';
import { Router } from '@angular/router';
import { SubscriptionDetailsComponent } from 'src/app/master-config-components/micro-apps/business/subscription/subscription-details/subscription-details.component';
import { PricingDetailsComponent } from 'src/app/shared-module-files/components/pricing-details/pricing-details.component';

@Component({
  selector: 'app-v3-view-site',
  templateUrl: './v3-view-site.component.html',
  styleUrls: ['./v3-view-site.component.scss']
})
export class V3ViewSiteComponent {
  constructor(
    public dialogRef: MatDialogRef<V3ViewSiteComponent>,
    private bottomSheet: MatBottomSheetRef<V3ViewSiteComponent>,
    private templateService: TemplateService,
    private _paymentService: PaymentsService,
    private _websiteService: WebisiteService,
    private router: Router
  ) {
    this.getScreenSize();
  }
  businessDetails: any
  private templateId: string | null = null;
  ngOnInit(): void {
    let bDetails = window.localStorage.getItem('bDetails');
    if (bDetails) {
      this.businessDetails = JSON.parse(bDetails);
      this.templateId = this.businessDetails.templateId;
    }

  }
  screenWidth: number = 0;
  @HostListener('window:resize', ['$event'])
  getScreenSize() {
    this.screenWidth = window.innerWidth;
  }
  closePopup() {
    if (this.screenWidth > 475) {
      this.dialogRef.close()
    }

    if (this.screenWidth < 475) {
      this.bottomSheet.dismiss()
    }
  }
  dnsDomainUrl: any;
  dnsVerified: any;
  goToSettingsSubscribe: any;
  upgradePlan() {
    if (this.goToSettingsSubscribe) {
      this.goToSettingsSubscribe.unsubscribe();


    }
    let popup = this._paymentService.openDialog(
      PricingDetailsComponent,
      '100%',
      '100%',
      '100%'
    )
    // else {
    //   let popup = this.templateService.openDialogWithData(
    //     LinkDomainComponent,
    //     'auto',
    //     '390px',
    //     {
    //       'dnsDomainUrl': this.dnsDomainUrl,
    //       'dnsVerified': this.dnsVerified,
    //     }
    //   )
    //   popup.afterClosed().subscribe(
    //     (res: any) => {
    //       if (res.data === null) {

    //       }
    //       else {
    //         this.checkDomain(res.data, res.domainUrl, res.businessId);
    //       }
    //     }
    //   )
    // }
  }
  businessId: any;
  checkDomain(data, domainUrl, businessId) {
    let checkDomain = new CustomEvent('checkDomain', {
      detail: {
        domain: domainUrl,
        config: data
      }
    });

    let checkingDomain = document.dispatchEvent(checkDomain)
    this.businessId = businessId;
    if (checkingDomain) {
      this.showEntri(data)
    }
    else {
      let popup = this.templateService.openDialogWithData(
        StepsToFollowComponent,
        'auto',
        '625px',
        {
          'dnsDomainUrl': this.dnsDomainUrl,
          'dnsVerified': this.dnsVerified,
        }
      )
    }
  }
  callbackFunctionSubscription: any;
  snackbar: any;
  showEntri(data) {
    const showEntri = new CustomEvent('showEntri', {
      detail: {
        applicationId: data.applicationId,
        token: data.token,
        dnsRecords: data.dnsRecords
      },
    });


    let self = this;
    let showEntriChecks = document.dispatchEvent(showEntri);

    function handleOnEntriClose(event) {


      window.removeEventListener('onEntriClose', handleOnEntriClose, false);
      if (event.detail.success) {
        let a = event.detail;
        // let businessId = localStorage.getItem('businessId');
        a = { ...a, businessId: localStorage.getItem('businessId') }
        self.templateService.openDialogWithData(
          ProcessInprogressComponent,
          'auto',
          '600px',
          { data: null }
        )
        self._websiteService.callBackEntriMethod(a).subscribe(
          (res: any) => {

            if (res.data) {

              // self.notifyPopup();
            }
            else {
              self.snackbar = self.snackbar.openFromComponent(
                CustomSnackbarComponent,
                {
                  data: {
                    type: 'ERROR',
                    message: `Oops...! Something went wrong`,
                    buttonText: "Close",
                    snackbar: self.snackbar
                  },
                  duration: 1500,
                  panelClass: 'error-snackbar'
                }
              );
            }
          },
          (err) => {

            self.snackbar = self.snackbar.openFromComponent(
              CustomSnackbarComponent,
              {
                data: {
                  type: 'ERROR',
                  message: `Oops...! Something went wrong`,
                  buttonText: "Close",
                  snackbar: self.snackbar
                },
                duration: 1500,
                panelClass: 'error-snackbar'
              }
            );
          }
        );
      }
    }
    window.addEventListener('onEntriClose', handleOnEntriClose, false);
  }
  viewPerview() {
    window.open(this.businessDetails.domainUrl ? this.businessDetails.domainUrl : this.businessDetails.websiteUrl, '_blank')?.focus();
  }

  get siteUrl(): string {
    return this.businessDetails?.domainUrl || this.businessDetails?.websiteUrl || '';
  }

  copied = false;
  private copiedResetTimeout: any;
  copyUrl() {
    if (!this.siteUrl) return;
    navigator.clipboard?.writeText(this.siteUrl).then(() => {
      this.copied = true;
      clearTimeout(this.copiedResetTimeout);
      this.copiedResetTimeout = setTimeout(() => this.copied = false, 1500);
    });
  }
}
